import { ReduxState } from '@/redux/modules/types';
import { useSelector } from 'react-redux';

type actionLoaderDefinition = {
  [key: string]: React.ElementType;
};
export const useLoadingState = (actionLoaderDefinition: actionLoaderDefinition) => {
  const loaders = useSelector((state: ReduxState) => state.ui.loaders);
  const targetLoader = loaders.actions.find(action => actionLoaderDefinition[action.name]);
  return {
    LoaderComponent: targetLoader ? actionLoaderDefinition[targetLoader.name] : undefined,
    isLoading: !!targetLoader,
  };
};

/**
 * Return the loading state of a specific redux action
 *
 * @param name the redux Action name
 * @returns boolean of the loading state
 */
export const useLoadingUIState = (name: string) => {
  const loaders = useSelector((state: ReduxState) => state.ui.loaders);
  const isLoading = loaders.actions.some(action => action.name === name);
  return !!isLoading;
};
